import React from 'react';
import { Modal, Form, Input, Button, Select, Radio } from 'antd';
import { EyeOutlined, LockOutlined } from '@ant-design/icons';

const { Option } = Select;

const GroupModal = ({
    isModalVisible,
    handleCancel,
    groupUsers,
    groupName,
    handleGroupName,
    handleGroupUsers,
    handleCreateGroup,
    people,
    visibility,
    handleVisibility, // New handler for visibility
}) => {
    return (
        <Modal
            title="Create Group"
            visible={isModalVisible}
            onCancel={handleCancel}
            zIndex={1002}   // higher than sidebar
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button key="create" type="primary" onClick={handleCreateGroup}>
                    Create
                </Button>,
            ]}
            bodyStyle={{ padding: '20px' }} // Adding padding inside the modal body
        >
            <Form
                layout="vertical"
                style={{ padding: '10px', borderRadius: '8px', background: '#f9f9f9' }} // Adding spacing and a background color
            >
                <Form.Item
                    label="Group Name"
                    required
                    style={{ marginBottom: '20px' }} // Adding space between fields
                >
                    <Input
                        value={groupName}
                        onChange={(e) => handleGroupName(e.target.value)}
                        placeholder="Enter group name"
                    />
                </Form.Item>
                <Form.Item
                    label="Select Users"
                    required
                    style={{ marginBottom: '20px' }}
                >
                    <Select
                        mode="multiple"
                        style={{ width: '100%' }}
                        placeholder="Select users for the group"
                        value={groupUsers}
                        onChange={(e) => handleGroupUsers(e)}
                        filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {people.map((person) => (
                            <Option key={person.Name} value={person._id}>
                                {person.Name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Visibility"
                    required
                    style={{ marginBottom: '20px' }}
                >
                    <Radio.Group
                        value={visibility}
                        onChange={(e) => handleVisibility(e.target.value)}
                    >
                        <Radio value="public" style={{ marginBottom: '10px'}}>
                            <EyeOutlined style={{ marginRight: '2px' }} />
                            Public
                        </Radio>
                        <Radio value="private" style={{ marginLeft: '20px' }}>
                            <LockOutlined  style={{ marginRight: '2px' }} />
                            Private
                        </Radio>
                    </Radio.Group>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default GroupModal;
